import { postRequestFactory, createClient, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AcceptCommand {}

const client = createClient('/rest/operator-api/charging-stations');

export const accept: SaveOperation<AcceptCommand, void, string> = postRequestFactory<AcceptCommand, void, string>(
  client,
  { pattern: '/{chargingStationId}/accept', permissionId: commandPermissions.ACCEPT_CHARGING_STATION }
);
